const newgameLotto = {
  th: {
    ng: {
      lotto: {
        betTypeTabs: "ประเภทการแทงหวย",
        nineteenDoors: "19 ประตู",
        threeReverse: "สามตัวกลับ",
        twoReverse: "สองตัวกลับ",
        resultsTable: "ตารางผลหวย",
        countdownDays: "{{count}} วัน {{time}}",
        itemCount: "{{count}} รายการ",
        numberEntryTabs: "วิธีระบุตัวเลข",
        cannotEnterGame: "ไม่สามารถเข้าเกมได้",
        closePriceEntry: "ปิดหน้าต่างใส่ราคา",
        drawClosed: "หวยงวดนี้ปิดรับแทงแล้ว",
        pleaseTryAgain: "กรุณาลองใหม่!",
        priceTable: "ตารางราคาแทง",
        promotionRestriction:
          "เนื่องจากอยู่นอกเงื่อนไขโปรโมชั่น กรุณาตรวจสอบเงื่อนไข",
        lotteryIcon: "ไอคอนหวย",
        twentyFourHours: "24 ชั่วโมง",
        twentyFourHoursShort: "24 ชม.",
        closeSeriesAndPull: "ปิดหน้าต่างเลขชุดและดึงโพย",
        numberSeries: "เลขชุด",
        seriesAndPull: "เลขชุด - ดึงโพย",
        betTime: "เวลาที่แทง",
        number: "เลข",
        createdAt: "เวลาที่สร้าง",
        seriesName: "ชื่อชุด",
        calendarIcon: "ไอคอนปฏิทิน",
        rewardIcon: "ไอคอนผลรางวัล",
        selectResultDate: "เลือกวันที่ออกรางวัล",
        closeRules: "ปิดกติกา",
        howToViewResults: "วิธีการดูผล",
        payoutChangeNote:
          "หมายเหตุ: ราคาจ่ายจะมีการเปลี่ยนแปลงตามจำนวนการแทง",
      },
    },
  },
  en: {
    ng: {
      lotto: {
        betTypeTabs: "Lottery bet types",
        nineteenDoors: "19-door numbers",
        threeReverse: "Three-digit permutations",
        twoReverse: "Two-digit permutations",
        resultsTable: "Lottery results table",
        countdownDays: "{{count}} days {{time}}",
        itemCount: "{{count}} items",
        numberEntryTabs: "Number entry methods",
        cannotEnterGame: "Unable to enter the game",
        closePriceEntry: "Close price entry",
        drawClosed: "Betting for this draw is closed",
        pleaseTryAgain: "Please try again!",
        priceTable: "Bet prices",
        promotionRestriction:
          "You do not meet the promotion conditions. Please review the conditions.",
        lotteryIcon: "Lottery icon",
        twentyFourHours: "24 hours",
        twentyFourHoursShort: "24 hrs",
        closeSeriesAndPull: "Close number series and bet-slip retrieval",
        numberSeries: "Number series",
        seriesAndPull: "Number series - Retrieve bet slip",
        betTime: "Bet time",
        number: "Number",
        createdAt: "Created at",
        seriesName: "Series name",
        calendarIcon: "Calendar icon",
        rewardIcon: "Lottery results icon",
        selectResultDate: "Select result date",
        closeRules: "Close rules",
        howToViewResults: "How to view results",
        payoutChangeNote:
          "Note: Payout rates may change according to the volume of bets.",
      },
    },
  },
  cn: {
    ng: {
      lotto: {
        betTypeTabs: "彩票投注类型",
        nineteenDoors: "19 门",
        threeReverse: "三位数全排列",
        twoReverse: "两位数全排列",
        resultsTable: "开奖结果表",
        countdownDays: "{{count}} 天 {{time}}",
        itemCount: "{{count}} 项",
        numberEntryTabs: "号码输入方式",
        cannotEnterGame: "无法进入游戏",
        closePriceEntry: "关闭投注金额设置",
        drawClosed: "本期开奖已停止投注",
        pleaseTryAgain: "请重试！",
        priceTable: "投注金额表",
        promotionRestriction: "由于不符合优惠活动条件，请检查相关条件。",
        lotteryIcon: "彩票图标",
        twentyFourHours: "24 小时",
        twentyFourHoursShort: "24 小时",
        closeSeriesAndPull: "关闭组合号码和提取注单",
        numberSeries: "组合号码",
        seriesAndPull: "组合号码 - 提取注单",
        betTime: "投注时间",
        number: "号码",
        createdAt: "创建时间",
        seriesName: "组合名称",
        calendarIcon: "日历图标",
        rewardIcon: "开奖结果图标",
        selectResultDate: "选择开奖日期",
        closeRules: "关闭规则",
        howToViewResults: "如何查看结果",
        payoutChangeNote: "注意：赔付率会根据投注量而调整。",
      },
    },
  },
  mm: {
    ng: {
      lotto: {
        betTypeTabs: "ထီလောင်းကြေး အမျိုးအစားများ",
        nineteenDoors: "၁၉ ပေါက်",
        threeReverse: "သုံးလုံး ပြန်လှန်",
        twoReverse: "နှစ်လုံး ပြန်လှန်",
        resultsTable: "ထီရလဒ် ဇယား",
        countdownDays: "{{count}} ရက် {{time}}",
        itemCount: "{{count}} ခု",
        numberEntryTabs: "ဂဏန်းထည့်သွင်းနည်းများ",
        cannotEnterGame: "ဂိမ်းထဲသို့ ဝင်၍မရပါ",
        closePriceEntry: "လောင်းကြေးထည့်သွင်းမှု ပိတ်ရန်",
        drawClosed: "ဤအကြိမ်အတွက် လောင်းကြေးပိတ်ပြီးပါပြီ",
        pleaseTryAgain: "ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ!",
        priceTable: "လောင်းကြေး ဇယား",
        promotionRestriction:
          "ပရိုမိုးရှင်း စည်းကမ်းချက်များနှင့် မကိုက်ညီသောကြောင့် စည်းကမ်းချက်များကို စစ်ဆေးပါ။",
        lotteryIcon: "ထီ သင်္ကေတ",
        twentyFourHours: "၂၄ နာရီ",
        twentyFourHoursShort: "၂၄ နာရီ",
        closeSeriesAndPull: "ဂဏန်းအတွဲနှင့် ထိုးစာရင်းပြန်ယူမှုကို ပိတ်ရန်",
        numberSeries: "ဂဏန်းအတွဲ",
        seriesAndPull: "ဂဏန်းအတွဲ - ထိုးစာရင်းပြန်ယူရန်",
        betTime: "ထိုးသည့်အချိန်",
        number: "ဂဏန်း",
        createdAt: "ဖန်တီးချိန်",
        seriesName: "အတွဲအမည်",
        calendarIcon: "ပြက္ခဒိန် သင်္ကေတ",
        rewardIcon: "ဆုရလဒ် သင်္ကေတ",
        selectResultDate: "ဆုထွက်ရက် ရွေးချယ်ရန်",
        closeRules: "စည်းမျဉ်းများ ပိတ်ရန်",
        howToViewResults: "ရလဒ်ကြည့်ရှုနည်း",
        payoutChangeNote:
          "မှတ်ချက်။ လောင်းကြေးပမာဏပေါ် မူတည်၍ အလျော်နှုန်း ပြောင်းလဲနိုင်သည်။",
      },
    },
  },
};

export default newgameLotto;
